import { getTenantId } from '../../utils/oidcUtil';

import { AuthSessionStatus, IAuthSessionState } from './types';
import { AUTH_SESSION_ID_KEY } from './const';

export const buildSessionKey = (): string => {
  const tenantId = getTenantId();
  return `${AUTH_SESSION_ID_KEY}.${tenantId}`;
};

export const isAuthPending = (authState: IAuthSessionState): boolean => {
  return authState.status === AuthSessionStatus.Loading || authState.status === AuthSessionStatus.Redirection;
};

export const isAuthChallenged = (authState: IAuthSessionState): boolean => {
  return authState.status === AuthSessionStatus.Challenged;
};

export const isAuthCompleted = (authState: IAuthSessionState): boolean => {
  return authState.status === AuthSessionStatus.NotRequired || authState.status === AuthSessionStatus.SignedIn;
};
